export class TableField {
  public key: string = '';
  public label: string = '';
  public sortable: boolean = false;
  public formatter: any;

  constructor(data?: any) {
    if (data) {
      for (const property in data) {
        if (data.hasOwnProperty(property)) {
          (this as any)[property] = (data as any)[property];
        }
      }
    }
  }
}
